import React from 'react';
import BillProductsList from './BillProductsList';
import BillProductsFormService from '../services/BillProductsFormService';
import BillFormService from '../services/BillFormService';
import { toJS } from 'mobx';
import { BRAZIL } from '../../../core/consts';

const BillProductsListContainer = (props) => (
  <BillProductsList
    readOnly={props.readOnly}
    onDelete={BillProductsFormService.handleDelete}
    onEdit={BillProductsFormService.handleEdit}
    submitting={BillFormService.submit.fetching}
    data={toJS(BillFormService.form.getValue('products'))}
    currencyType={
      !BillFormService.form.getValue('country') || BRAZIL.includes(BillFormService.form.getValue('country'))
        ? 'real'
        : 'dollar'
    }
  />
);

export default BillProductsListContainer;
